<form
    [formGroup]="employeeFormGroup"
    (ngSubmit)="saveEmployee()"
    class="modal-wrapper">
    <div class="modal-header">
        <h2
            class="modal-title"
            id="exampleModalLabel">
            Edit Employee
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Firstname</label>
                    <input
                        type="text"
                        formControlName="firstName"
                        trim="blur"
                        #focussed />

                    <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">
                        <span
                            class="form-error"
                            *ngIf="firstName.errors.minlength"
                            >First name required and needs to be at least 2 characters long</span
                        >
                        <span
                            class="form-error"
                            *ngIf="firstName.errors.maxlength"
                            >First name required and can not be longer then 30 characters</span
                        >
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Lastname</label>
                    <input
                        type="text"
                        formControlName="lastName"
                        trim="blur" />

                    <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)">
                        <span
                            class="form-error"
                            *ngIf="lastName.errors.minlength"
                            >Last name required and needs to be at least 2 characters long</span
                        >
                        <span
                            class="form-error"
                            *ngIf="lastName.errors.maxlength"
                            >Last name required and can not be longer then 30 characters</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group m-b-2">
                    <label>Profession</label>
                    <input
                        type="text"
                        placeholder="profession"
                        formControlName="profession" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group m-b-2">
                    <label>Work Percentage</label>
                    <input
                        type="number"
                        min="1"
                        max="100"
                        step="1"
                        placeholder="100"
                        formControlName="workPercentage" />
                    <span class="form-helptext">100 = full-time (8h), 80 = 80% (6.4h), 60 = 60% (4.8h)</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Type</label>
                    <select formControlName="type">
                        <option value="PAYROLL">Payroll</option>
                        <option value="FREELANCE">Freelance</option>
                    </select>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group m-b-2">
                    <label>SD Worx werknemer nr.</label>
                    <input
                        type="text"
                        placeholder="Bijv. 0000046"
                        formControlName="sdWorxEmployeeNumber"
                        trim="blur" />
                </div>
            </div>
        </div>

        <h3 class="m-t-4 m-b-4">Employee information</h3>

        <div formGroupName="contactInformation">
            <div class="form-group m-b-2">
                <label>Phonenumber</label>
                <input
                    type="text"
                    placeholder="Phonenumber"
                    formControlName="phoneNumber"
                    trim="blur" />
                <span class="form-helptext">Not your personal phonenumber!</span>
            </div>

            <div class="form-group m-b-2 required">
                <label>Emailaddress</label>
                <input
                    type="email"
                    placeholder="Emailaddress"
                    formControlName="email"
                    trim="blur" />

                <div *ngIf="email.invalid && (email.dirty || email.touched)">
                    <span
                        class="form-error"
                        *ngIf="email.errors.email"
                        >Enter a valid email</span
                    >
                </div>

                <span class="form-helptext">Probably something like contactemployee@thiscompany.com ...</span>
            </div>

            <div class="form-group m-b-2">
                <label>LinkedIn</label>
                <input
                    type="text"
                    placeholder="LinkedIn"
                    formControlName="linkedIn" />
            </div>

            <div class="form-group m-b-2">
                <label>Tags</label>
                <app-global-tags
                    [objectUuid]="employeeUuid"
                    [type]="'employee'"></app-global-tags>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Birthday</label>
                    <input
                        type="date"
                        formControlName="birthday" />
                    <span
                        class="form-error"
                        *ngIf="inputIsWrong"
                        >Birthday must be before the hire date</span
                    >
                    <span
                        class="form-error"
                        *ngIf="employeeFormGroup.controls.birthday.errors && inputIsWrong"
                        >Birthday required</span
                    >
                    <span
                        class="form-error"
                        *ngIf="employeeFormGroup.get('birthday').hasError('required') && employeeFormGroup.get('birthday').touched"
                        >Birthday is required</span
                    >
                </div>
            </div>
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Hire Date</label>
                    <input
                        type="date"
                        formControlName="hireDate" />
                    <span
                        class="form-error"
                        *ngIf="inputIsWrong"
                        >Hire date can not be before the birthday</span
                    >
                    <span
                        class="form-error"
                        *ngIf="employeeFormGroup.controls.hireDate.errors && inputIsWrong"
                        >Hire date required</span
                    >
                </div>
            </div>
        </div>
        <div class="form-group m-b-2">
            <label>Extra info</label>
            <textarea
                class="resize-vertical"
                formControlName="extraInfo"
                trim="blur"></textarea>
            <small><span *ngIf="currentAmountOfExtraInfoCharacters === null">0</span>{{ currentAmountOfExtraInfoCharacters }}/{{ EXTRAINFO_MAX_LENGTH }}</small>

            <div *ngIf="extraInfo.invalid && (extraInfo.dirty || extraInfo.touched)">
                <span
                    class="form-error"
                    *ngIf="extraInfo.errors.maxlength"
                    >Extra info cannot contain more than {{ EXTRAINFO_MAX_LENGTH }} characters</span
                >
            </div>
        </div>

        <div>
            <div *ngIf="!jiraEmployeeIdListLoaded">Loading Jira Id list...</div>
            <div class="form-group m-b-2" *ngIf="jiraEmployeeIdListLoaded">
                <label>Jira Employee ID</label>
                <select formControlName="jiraEmployeeId">
                    <option value="">Choose the corresponding Jira Employee Id</option>
                    <option *ngFor="let credential of jiraEmployeeIdList$" [value]="credential.jiraEmployeeId">
                        {{credential.employeeName}} - {{credential.jiraEmployeeId}}
                    </option>
                </select>
            </div>
        </div>
        
        <div>
            <span
                class="form-error"
                *ngIf="employeeWentWrong"
                >{{ errorMessage }}</span
            >
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="button button--outline"
            (click)="activeModal.close()">
            Close
        </button>
        <button
            type="submit"
            [ngClass]="{ 'button--loading': loading }"
            class="button button--primary">
            Edit Employee
        </button>
    </div>
</form>
